import Icon from '../components/Icon.vue'

Icon.register({
  teeth: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M544 0H96C43 0 0 43 0 96V416C0 469 43 512 96 512H544C597 512 640 469 640 416V96C640 43 597 0 544 0zM160 368C160 394.5 138.5 416 112 416S64 394.5 64 368V304C64 295.2 71.2 288 80 288H144C152.8 288 160 295.2 160 304V368zM160 240C160 248.8 152.8 256 144 256H80C71.2 256 64 248.8 64 240V176C64 149.5 85.5 128 112 128S160 149.5 160 176V240zM304 360C304 390.9 278.9 416 248 416S192 390.9 192 360V304C192 295.2 199.2 288 208 288H288C296.8 288 304 295.2 304 304V360zM304 240C304 248.8 296.8 256 288 256H208C199.2 256 192 248.8 192 240V152C192 121.1 217.1 96 248 96S304 121.1 304 152V240zM448 360C448 390.9 422.9 416 392 416S336 390.9 336 360V304C336 295.2 343.2 288 352 288H432C440.8 288 448 295.2 448 304V360zM448 240C448 248.8 440.8 256 432 256H352C343.2 256 336 248.8 336 240V152C336 121.1 361.1 96 392 96S448 121.1 448 152V240zM576 368C576 394.5 554.5 416 528 416S480 394.5 480 368V304C480 295.2 487.2 288 496 288H560C568.8 288 576 295.2 576 304V368zM576 240C576 248.8 568.8 256 560 256H496C487.2 256 480 248.8 480 240V176C480 149.5 501.5 128 528 128S576 149.5 576 176V240z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/teeth.js
// module id = ZFaE
// module chunks = 144